import React, { useState, useEffect } from 'react';
import { UserPlus, Calendar, User, Clock, Share2, BookOpen, Shield, AlertTriangle, Phone, Scale, CheckCircle, Users, FileText, TrendingUp, Lock, Eye } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPost5 = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] py-12 sm:py-20 mt-20">
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <BookOpen className="w-4 h-4 sm:w-6 sm:h-6" />
            <span className="text-white font-semibold text-sm sm:text-base">المدونة القانونية</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight px-2 text-white">
            دليلك لعقود العمل وحقوق الموظف في النظام السعودي
          </h1>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white text-sm sm:text-base">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>فبراير 2025</span>
            </div>
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>شركة أنس للمحاماة</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>15 دقيقة قراءة</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden">
          
          {/* Article Header */}
          <div className="p-4 sm:p-8 border-b border-gray-100">
            <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <p className="text-sm sm:text-base md:text-lg text-[#0a3a23] font-semibold">
                <strong>إشراف: شركة أنس للمحاماة والاستشارات القانونية</strong>
              </p>
            </div>
          </div>

          {/* Introduction */}
          <div className="p-4 sm:p-8">
            <div className="mb-6 sm:mb-8">
              <img 
                src="/images/blog/Blog25.png" 
                alt="عقود العمل" 
                className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                في عالم الأعمال المعاصر، يشكل عقد العمل حجر الأساس في تنظيم العلاقة بين صاحب العمل والموظف، ويحدد الحقوق والواجبات بشكل يحقق التوازن ويحفظ مصالح جميع الأطراف. لا تقتصر أهمية عقد العمل على الناحية الإجرائية فقط، بل تمتد لتكون ضمانة قانونية تحمي الأطراف من أي تجاوز أو نزاع محتمل.
              </p>
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                في هذه المقالة، نستعرض أبرز ملامح عقود العمل في النظام السعودي، ونوضح حقوق الموظف والضمانات القانونية التي يوفرها النظام، مع التركيز على أهمية الوعي القانوني في بناء علاقة مهنية مستقرة وناجحة.
              </p>
              
              <div className="bg-[#0a3a23]/20 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  <strong>المعرفة القانونية أساس العلاقة المهنية الناجحة</strong>
                </p>
              </div>
            </div>

            {/* Section 1 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <FileText className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعريف عقد العمل وضوابطه القانونية</h2>
              </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
              <div>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  عرف عقد العمل بأنه الاتفاق المبرم بين صاحب العمل والعامل، والذي يتعهد فيه الأخير بأداء العمل تحت إدارة صاحب العمل أو إشرافه مقابل أجر محدد (المادة 50 من نظام العمل السعودي). ويشترط النظام أن يكتب عقد العمل بنسختين، بحيث يحتفظ كل طرف بنسخته الخاصة، ويجب أن يكون محدد المدة للعامل غير السعودي، وإذا لم تحددمدة العقد تكون مدة رخصة العمل هي مدة العقد القانونية.
                </p>
              </div>
                <div>
                  <img 
                    src="/images/blog/Blog21.png" 
                    alt="عقد العمل" 
                    className="w-full h-40 sm:h-48 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">إثبات العقد</h4>
                  <p className="text-sm sm:text-base text-gray-800">منح العامل وحده حق إثبات العقد، حتى وإن لم يكن مكتوباً، وفي هذه الحالة يعتبر العقد قائماً وحقوقه بكافة طرق الإثبات. ويحق لأي من الطرفين طلب كتابة العقد في أي وقت.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">القرارات الحكومية</h4>
                  <p className="text-sm sm:text-base text-gray-800">قرار أو أمر التعيين بالنسبة لعمال القطاع الحكومي والمؤسسات العامة يقوم مقام عقد العمل (المادة 51).</p>
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">محتوى عقد العمل وشروطه الجوهرية</h2>
              </div>
              
              <img 
                src="/images/blog/Blog22.png" 
                alt="محتوى عقد العمل" 
                className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                يتعين أن يحتوي عقد العمل على معلومات أساسية مثل:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">معلومات العامل</h4>
                  <ul className="space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-800">
                    <li>• اسم العامل وجنسيته</li>
                    <li>• ما يلزم لإثبات شخصية العامل</li>
                  </ul>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">معلومات العمل</h4>
                  <ul className="space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-800">
                    <li>• اسم صاحب العمل ومكانه</li>
                    <li>• الأجر المتفق عليه، والمزايا والبدلات</li>
                  </ul>
                </div>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl mt-4 sm:mt-6">
                <p className="text-sm sm:text-base text-gray-800">
                  <strong>النموذج الموحد:</strong> يجب أن يكون عقد العمل متوافقاً مع النموذج الموحد الذي تضعه وزارة العمل، وللطرفين إضافة بنود أخرى شريطة عدم تعارضها مع النظام ولائحته التنفيذية.
                </p>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Lock className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">الإجازات وحقوق الموظف في النظام السعودي</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
                <div>
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                    ينظم النظام السعودي الإجازات بشكل يراعي مصالح الطرفين ويحقق التوازن بين العمل والحياة الشخصية للموظف، ومن أبرز الإجازات:
                  </p>
                </div>
                <div>
                  <img 
                    src="/images/blog/Blog23.png" 
                    alt="الإجازات" 
                    className="w-full h-40 sm:h-48 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
              
              <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-800">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>الإجازة السنوية:</strong> يحصل الموظف على 21 يوماً سنوياً، وتزداد إلى 30 يوماً بعد خمس سنوات من الخدمة، تقديراً للاستمرارية والإخلاص.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>الإجازة المرضية:</strong> تمنح لمدة 30 يوماً بأجر كامل، ثم 60 يوماً بنسبة 75% من الأجر، يليها 30 يوماً بدون أجر.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>إجازات المناسبات:</strong> تشمل إجازات للزواج، الوفاة، الولادة، والأعياد، حرصاً على توفير بيئة عمل متوازنة.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 4 - حقوق المرأة العاملة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">حقوق المرأة العاملة</h2>
              </div>
              
              <img 
                src="/images/صور الموقع (1)/7.jpg" 
                alt="حقوق المرأة العاملة" 
                className="w-full h-auto object-contain rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                تحظى المرأة العاملة بحماية قانونية خاصة مثل:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">الحماية من الفصل</h4>
                  <p className="text-sm sm:text-base text-gray-800">الحماية من الفصل أثناء الحمل</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">ساعة الرضاعة</h4>
                  <p className="text-sm sm:text-base text-gray-800">ساعة يومية للرضاعة لتسهيل دور الأمومة</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">الحضانة الطبية</h4>
                  <p className="text-sm sm:text-base text-gray-800">حق الحضانة الطبية أثناء الحمل والولادة</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">تهيئة ظروف العمل</h4>
                  <p className="text-sm sm:text-base text-gray-800">تهيئة ظروف العمل لتلبية احتياجات المرأة</p>
                </div>
              </div>
            </div>

            {/* Section 5 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Scale className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">ساعات العمل والخصومات المالية</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
                <div>
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                    يحدد النظام ساعات العمل بحيث لا تتجاوز 8 ساعات يومياً أو 48 ساعة أسبوعياً، وتخفض إلى 6 ساعات يومياً في شهر رمضان للمسلمين. أما الخصومات من الأجر، فلا يمكن أن تتجاوز نصف الأجر إلا بقرار قضائي، بما يضمن حماية الموظف من التعسف المالي.
                  </p>
                </div>
                <div>
                  <img 
                    src="/images/blog/Blog31.png" 
                    alt="ساعات العمل" 
                    className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
            </div>

            {/* Conclusion */}
            <div className="mb-8 sm:mb-12">
              <div className="bg-[#0a3a23]/10 p-6 sm:p-8 rounded-xl sm:rounded-2xl">
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">خاتمة</h3>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  إن معرفة تفاصيل عقد العمل ليست ترفاً قانونياً، بل ضرورة لكل موظف وصاحب عمل يسعى إلى بناء علاقة قائمة على الثقة والاستدامة. يمثل الوعي بالحقوق والواجبات خط الدفاع الأول أمام أي موقف غير عادل أو نزاع محتمل، ويضع الأساس لعلاقة مهنية مستقرة ومثمرة.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  لذا ينصح جميع العاملين وأصحاب الأعمال بالاطلاع الدقيق على بنود العقد وفهمها والاستعانة بذوي الخبرة القانونية عند الحاجة لضمان حماية الحقوق وتحقيق بيئة عمل عادلة ومتوازنة.
                </p>
              </div>
            </div>


            {/* Call to Action */}
            <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-xl sm:rounded-2xl text-white text-center">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">هل تحتاج استشارة في قضايا عقود العمل؟</h3>
              <p className="text-white/90 mb-4 sm:mb-6 text-sm sm:text-base">
                تواصل مع شركة أنس للمحاماة للحصول على استشارة قانونية متخصصة في عقود العمل وحقوق الموظفين
              </p>
              <a
                href="https://wa.me/966115115945?text=أريد استشارة قانونية في قضايا عقود العمل وحقوق الموظفين"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-[#0a3a23] px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-bold hover:bg-gray-100 hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
              >
                احجز استشارة الآن
              </a>
            </div>

            {/* Author Section */}
            <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#0a3a23]/10 to-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <div className="flex items-center">
                <p className="text-sm sm:text-base text-[#0a3a23] font-semibold">
                  <strong>المحامية المتدربة: صالحه فواز </strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Share Section */}
        <div className="mt-6 sm:mt-8 text-center">
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <Share2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
            <span className="text-gray-600 font-semibold text-sm sm:text-base">شارك المقال</span>
          </div>
          <div className="flex justify-center gap-3 sm:gap-4">
            <a
              href="https://x.com/khayatlawfirm?t=jAXcLytECVDZ2DRxkSLPWg&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              تويتر
            </a>
            <a
              href="https://www.instagram.com/khayatlawfirm?igsh=MTRmNXByeDBnOGxucw=="
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              انستجرام
            </a>
          </div>
        </div>
      </div>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة قانونية في قضايا عقود العمل وحقوق الموظفين"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <Footer />
    </div>
  );
};

export default BlogPost5;

